export default __webpack_public_path__ + "static/media/TRUCK12.627a5cf0.jpg";